var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgexport5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 243,
    viewBox: "0 0 380 243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#212121",
    strokeWidth: "0.75px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5 32.708L90.804 81 160.5 6",
    stroke: "#212121",
    fill: "none",
    strokeWidth: "0.75px"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#212121",
    fill: "none",
    strokeWidth: "0.75px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.79.305L237.846 236.957M.03 102.52L208.597 148.235",
    transform: "translate(.5 6)",
    stroke: "#212121",
    fill: "none",
    strokeWidth: "0.75px"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19L52.5 120M52.5 120L90.5 82M142.5 94L159.5 143M175.5 54L141.5 94M320.5 91L175.5 54M203.5 1L225.5 67M225.5 1L209.5 18M305.5 43L209.5 18M291.5 2L305.5 44M340.5 1L274.5 79M90.5 81L142.5 94M73.5 33L105.5 0M18.5 18L73.5 33M71.5 172L107.5 132M122.5 183L159.5 143M157.5 214L208.5 154M122.5 183L14.5 160M175.5 194L191.5 243M192.5 104L336.5 137M320.5 91L336.5 137M379.5 23L320.5 91M377.5 88L336.5 138M122.5 183L132.5 214M208.5 154L306.5 175M290.5 127L257.5 165M334.5 9L351.5 56",
    stroke: "#212121",
    fill: "none",
    strokeWidth: "0.75px"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport5);
export default __webpack_public_path__ + "static/media/svgexport-5.63a6599920a0c43d65ef39b554715c4f.svg";
export { ForwardRef as ReactComponent };